import { $ } from "@/common/Axios";

export default {
  /**
   * 收藏
   */
  collect: {
    /*
     * 收藏|取消收藏
     * contentId 内容id (integer query required)
     * type 类型：知识点，习题 (string query required)
     */
    post: (p, c) => $.post("/api/sms/study/collect", p, c),
  },
  collect_listCollectCourseKnowledge: {
    /*
     * 课程(知识点)收藏列表
     * courseType 课程类型:成教，成考，专升本 (string query required)
     */
    get: (p, c) =>
      $.get("/api/sms/study/collect/listCollectCourseKnowledge", p, c),
  },
  collect_listCollectCourseSubject: {
    /*
     * 课程(习题)收藏列表
     * courseType 课程类型:成教，成考，专升本 (string query required)
     */
    get: (p, c) =>
      $.get("/api/sms/study/collect/listCollectCourseSubject", p, c),
  },
  collect_listCollectKnowledge: {
    /*
     * 知识点收藏列表
     * courseId 课程id (integer query required)
     */
    get: (p, c) => $.get("/api/sms/study/collect/listCollectKnowledge", p, c),
  },
  collect_listCollectPaper: {
    /*
     * 试卷收藏列表
     * courseId 课程id (integer query required)
     * type 类型: 历年真题,模拟测试、顺序练习、顺序练习-组卷 (string query required)
     */
    get: (p, c) => $.get("/api/sms/study/collect/listCollectPaper", p, c),
  },
  collect_listCollectSubject: {
    /*
     * 习题收藏列表
     * belongId 归属id (integer query required)
     * type 类型:直播课课后练习,章节练习,历年真题,模拟测试 (string query required)
     */
    get: (p, c) => $.get("/api/sms/study/collect/listCollectSubject", p, c),
  },
  collect_listKnowledgeForSelf: {
    /*
     * 自考习题题收藏列表（知识点）
     * courseId 课程id (integer query required)
     */
    get: (p, c) => $.get("/api/sms/study/collect/listKnowledgeForSelf", p, c),
  },
  collect_listSubjectForSelf: {
    /*
     * 自考习题收藏列表（习题）
     * knowledgeId 知识点id (integer query required)
     */
    get: (p, c) => $.get("/api/sms/study/collect/listSubjectForSelf", p, c),
  },

  /**
   * 评价
   */
  discuss: {
    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/sms/study/discuss", p, c),
  },
  discuss_discuss: {
    /*
     * 评价
     * content 评价详情 (string query )
     * contentId 内容id (integer query )
     * id  (integer query )
     * star 星级1-5星 (number query )
     * type 评价内容类型：线上课程，直播课程 (string query )
     * userId 用户id (integer query )
     */
    post: (p, c) => $.post("/api/sms/study/discuss/discuss", p, c),
  },
  discuss_listForCkOnline: {
    /*
     * 成考线上课程评价列表
     */
    get: (p, c) => $.get("/api/sms/study/discuss/listForCkOnline", p, c),
  },
  discuss_listForClient: {
    /*
     * 评价列表
     * contentId 评价内容id (integer query required)
     * type 评价内容:线上课程，直播课程 (string query required)
     */
    get: (p, c) => $.get("/api/sms/study/discuss/listForClient", p, c),
  },

  /**
   * 入学测试
   */
  entranceTest: {
    /*
     * 添加
     * ableStatus 启用状态 (string query )
     * content 内容 (string query )
     * id  (integer query )
     * level 层次，多个层次逗号隔开 (string query )
     * siteId 学校id (integer query )
     * title 标题 (string query )
     * type 类型:性格测试、逻辑测试 (string query )
     */
    post: (p, c) => $.post("/api/sms/study/entranceTest", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/sms/study/entranceTest", p, c),
  },
  entranceTest_details: {
    /*
     * 详情
     * schoolRollId 合同id (integer query required)
     * testId 测试id (integer query required)
     */
    get: (p, c) => $.get("/api/sms/study/entranceTest/details", p, c),
  },
  entranceTest_list: {
    /*
     * 入学测试列表
     */
    get: (p, c) => $.get("/api/sms/study/entranceTest/list", p, c),
  },
  entranceTest_listForClient: {
    /*
     * 入学测试C端列表
     * level 层次 (string query required)
     * schoolRollId 合同id (integer query required)
     * siteId 学校id (integer query required)
     */
    get: (p, c) => $.get("/api/sms/study/entranceTest/listForClient", p, c),
  },
  entranceTest_listSimple: {
    /*
     * 入学测试简易列表
     */
    get: (p, c) => $.get("/api/sms/study/entranceTest/listSimple", p, c),
  },

  /**
   * 入学测试题目
   */
  entranceTestSubject: {
    /*
     * 添加
     * answer 正确答案 (string query )
     * answerA 答案A (string query )
     * answerB 答案B (string query )
     * answerC 答案C (string query )
     * answerD 答案D (string query )
     * answerE 答案E (string query )
     * content 题目 (string query )
     * id  (integer query )
     * score 分值 (integer query )
     * sort 习题序号 (integer query )
     * testId 测试id (integer query )
     */
    post: (p, c) => $.post("/api/sms/study/entranceTestSubject", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/sms/study/entranceTestSubject", p, c),
  },
  entranceTestSubject_export: {
    /*
     * 导出
     * testId 测试id (integer query required)
     */
    get: (p, c) => $.get("/api/sms/study/entranceTestSubject/export", p, c),
  },
  entranceTestSubject_list: {
    /*
     * 列表
     * testId 测试id (integer query required)
     */
    get: (p, c) => $.get("/api/sms/study/entranceTestSubject/list", p, c),
  },
  entranceTestSubject_upload: {
    /*
     * 导入
     * excelFile excelFile (file formData required)
     * testId 测试id (integer query required)
     */
    post: (p, c) => $.post("/api/sms/study/entranceTestSubject/upload", p, c),
  },

  /**
   * 加入
   */
  join: {
    /*
     * 取消加入
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/sms/study/join", p, c),
  },
  join_batchJoinOnlineCourse: {
    /*
     * 批量加入(会删掉之前加入的)
     * contentIds 课程id (array query required)
     * courseType 课程类型：成教，成考，专升本 (string query required)
     */
    post: (p, c) => $.post("/api/sms/study/join/batchJoinOnlineCourse", p, c),
  },
  join_join: {
    /*
     * 加入（免费加入）
     * contentId 内容id (integer query )
     * id  (integer query )
     * type 类型:产品,线上课程,直播课程,线下课程 (string query )
     * userId 用户id (integer query )
     */
    post: (p, c) => $.post("/api/sms/study/join/join", p, c),
  },
  join_listStudentOnlineCourseForClient: {
    /*
     * 加入的线上课程列表
     * courseType 课程类型：成教，成考，专升本 (string query required)
     */
    get: (p, c) =>
      $.get("/api/sms/study/join/listStudentOnlineCourseForClient", p, c),
  },

  /**
   * 入学测试学生答题
   */
  studentEntranceTestSubject_exportForEnroll: {
    /*
     * 入学测试学生答题情况导出(招生端)
     */
    get: (p, c) =>
      $.get("/api/sms/study/studentEntranceTestSubject/exportForEnroll", p, c),
  },
  studentEntranceTestSubject_exportForSite: {
    /*
     * 入学测试学生答题情况导出(后端)
     */
    get: (p, c) =>
      $.get("/api/sms/study/studentEntranceTestSubject/exportForSite", p, c),
  },
  studentEntranceTestSubject_handSubject: {
    /*
     * 交卷
     * answers 答案 (array query required)
     * schoolRollId 合同id (integer query required)
     * subjectIds 题目id (array query required)
     * testId 测试 (integer query required)
     */
    post: (p, c) =>
      $.post("/api/sms/study/studentEntranceTestSubject/handSubject", p, c),
  },
  studentEntranceTestSubject_listForEnroll: {
    /*
     * 入学测试学生答题情况列表(招生端)
     */
    get: (p, c) =>
      $.get("/api/sms/study/studentEntranceTestSubject/listForEnroll", p, c),
  },
  studentEntranceTestSubject_listForSite: {
    /*
     * 入学测试学生答题情况列表(后端)
     */
    get: (p, c) =>
      $.get("/api/sms/study/studentEntranceTestSubject/listForSite", p, c),
  },

  /**
   * 学生刷题
   */
  studentExercise_detailForClient: {
    /*
     * 答题记录详情
     * id 答题记录id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/sms/study/studentExercise/detailForClient", p, c),
  },
  studentExercise_exportSkillTrainChapterExercise: {
    /*
     * 章节练习导出-技能培训
     */
    get: (p, c) =>
      $.get(
        "/api/sms/study/studentExercise/exportSkillTrainChapterExercise",
        p,
        c
      ),
  },
  studentExercise_exportSkillTrainMockExercise: {
    /*
     * 模拟测试导出列表-技能培训
     */
    get: (p, c) =>
      $.get(
        "/api/sms/study/studentExercise/exportSkillTrainMockExercise",
        p,
        c
      ),
  },
  studentExercise_handSubject: {
    /*
     * 交卷(返回练习id)
     * answers 答案 (array query required)
     * belongId 试卷或知识点id或直播课章节id (integer query required)
     * exerciseTime 练习时间（秒） (integer query required)
     * latestExerciseId 只有当继续练习的时候，把这个传给我 (integer query )
     * subjectIds 题目id (array query required)
     * type 类型：历年真题，模拟测试，章节练习，顺序练习 (string query required)
     */
    post: (p, c) => $.post("/api/sms/study/studentExercise/handSubject", p, c),
  },
  studentExercise_listAdultExamAssessmentStudentExercise: {
    /*
     * 成考摸底考试阅卷列表
     */
    get: (p, c) =>
      $.get(
        "/api/sms/study/studentExercise/listAdultExamAssessmentStudentExercise",
        p,
        c
      ),
  },
  studentExercise_listLatestStudentExerciseForClient: {
    /*
     * 学习记录
     * courseId 课程id (integer query )
     * type 类型: 历年真题,模拟测试、顺序练习、顺序练习-组卷 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/sms/study/studentExercise/listLatestStudentExerciseForClient",
        p,
        c
      ),
  },
  studentExercise_listSkillTrainChapterExercise: {
    /*
     * 章节练习列表-技能培训
     */
    get: (p, c) =>
      $.get(
        "/api/sms/study/studentExercise/listSkillTrainChapterExercise",
        p,
        c
      ),
  },
  studentExercise_listSkillTrainMockExercise: {
    /*
     * 模拟测试记录列表-技能培训
     */
    get: (p, c) =>
      $.get("/api/sms/study/studentExercise/listSkillTrainMockExercise", p, c),
  },
  studentExercise_read: {
    /*
     * 阅卷
     * id 学生试卷id (integer query required)
     * scores 分数 (array query required)
     * studentSubjectIds 学生答题id (array query required)
     */
    put: (p, c) => $.put("/api/sms/study/studentExercise/read", p, c),
  },

  /**
   * 学生知识点
   */
  studentKnowledge_exportSkillTranVideo: {
    /*
     * 视频观看导出-技能培训
     */
    get: (p, c) =>
      $.get("/api/sms/study/studentKnowledge/exportSkillTranVideo", p, c),
  },
  studentKnowledge_latestCourseId: {
    /*
     * 最近学习的课程id
     * courseType 课程类型：成考，成教 (string query required)
     */
    get: (p, c) =>
      $.get("/api/sms/study/studentKnowledge/latestCourseId", p, c),
  },
  studentKnowledge_listAdultExamQualityForClient: {
    /*
     * 最近学习的精品课章节
     */
    get: (p, c) =>
      $.get(
        "/api/sms/study/studentKnowledge/listAdultExamQualityForClient",
        p,
        c
      ),
  },
  studentKnowledge_listSkillTranVideo: {
    /*
     * 视频观看列表-技能培训
     */
    get: (p, c) =>
      $.get("/api/sms/study/studentKnowledge/listSkillTranVideo", p, c),
  },
  studentKnowledge_progress: {
    /*
     * 修改进度，切换视频（新老视频都调用），返回，播放结束，暂停，HOME等情况调用，学习1分钟
     * knowledgeId 知识点id (integer query required)
     * progress 进度 (integer query required)
     * study 0进度1学习 (integer query required)
     */
    put: (p, c) => $.put("/api/sms/study/studentKnowledge/progress", p, c),
  },
  studentKnowledge_searchRecordById: {
    /*
     * 根据studentKnowledgeId查询观看记录区间
     * studentKnowledgeId studentKnowledgeId (integer query required)
     */
    get: (p, c) =>
      $.get("/api/sms/study/studentKnowledge/searchRecordById", p, c),
  },

  /**
   * 学生直播学习记录
   */
  studentLiveCourseSchedule_exportStudentAdultExamLive: {
    /*
     * 成考学生直播观看情况导出
     * adultExamYear 成考年度 (string query required)
     * end 直播开始时间：结束 (string query )
     * start 直播开始时间：开始 (string query )
     * timeType 直播开始时间类型 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/sms/study/studentLiveCourseSchedule/exportStudentAdultExamLive",
        p,
        c
      ),
  },
  studentLiveCourseSchedule_listByStudent: {
    /*
     * 学生直播观看情况
     * course 直播课名字 (string query required)
     * level 直播课层次 (string query required)
     * userId 用户id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/sms/study/studentLiveCourseSchedule/listByStudent", p, c),
  },
  studentLiveCourseSchedule_updatePlaybackProgress: {
    /*
     * 修改回看进度，切换视频，返回，播放结束，暂停，HOME等情况调用
     * duration 回放时长 (integer query required)
     * liveCourseScheduleId 直播课表id (integer query required)
     * progress 进度 (integer query required)
     */
    put: (p, c) =>
      $.put(
        "/api/sms/study/studentLiveCourseSchedule/updatePlaybackProgress",
        p,
        c
      ),
  },
  studentLiveCourseSchedule_watchLive: {
    /*
     * 观看直播
     * liveCourseScheduleId 直播课表id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/sms/study/studentLiveCourseSchedule/watchLive", p, c),
  },

  /**
   * 自考学生提问
   */
  studentQuestion_answerForClient: {
    /*
     * C端追问
     * content 内容 (string query required)
     * id 提问列表id (integer query required)
     */
    post: (p, c) =>
      $.post("/api/sms/study/studentQuestion/answerForClient", p, c),
  },
  studentQuestion_answerForTeacher: {
    /*
     * 管理端回复
     * content 内容 (string query required)
     * id 提问列表id (integer query required)
     */
    post: (p, c) =>
      $.post("/api/sms/study/studentQuestion/answerForTeacher", p, c),
  },
  studentQuestion_batchUpdateStatus: {
    /*
     * 批量修改解决状态
     * ids ids (array query required)
     * status 解决状态 (string query required)
     */
    put: (p, c) =>
      $.put("/api/sms/study/studentQuestion/batchUpdateStatus", p, c),
  },
  studentQuestion_closeForClient: {
    /*
     * C端关闭会话
     * id 提问列表id (integer query required)
     */
    post: (p, c) =>
      $.post("/api/sms/study/studentQuestion/closeForClient", p, c),
  },
  studentQuestion_closeForTeacher: {
    /*
     * 管理端关闭会话
     * id 提问列表id (integer query required)
     */
    post: (p, c) =>
      $.post("/api/sms/study/studentQuestion/closeForTeacher", p, c),
  },
  studentQuestion_detail: {
    /*
     * 根据提问列表ID查询对话记录
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/sms/study/studentQuestion/detail", p, c),
  },
  studentQuestion_list: {
    /*
     * 自考精品课程学习反馈列表
     */
    get: (p, c) => $.get("/api/sms/study/studentQuestion/list", p, c),
  },
  studentQuestion_listForClient: {
    /*
     * C端自考精品课-我的提问列表
     */
    get: (p, c) => $.get("/api/sms/study/studentQuestion/listForClient", p, c),
  },
  studentQuestion_readForClient: {
    /*
     * C端点开聊天调用
     * lastAnswerId 提问列表返回的lastAnswerId (integer query required)
     */
    post: (p, c) =>
      $.post("/api/sms/study/studentQuestion/readForClient", p, c),
  },
  studentQuestion_saveForClient: {
    /*
     * C端自考提问
     * belongId 提问章节ID (integer query required)
     * content 提问内容 (string query required)
     * extraFileUrl 附件图片, 多个用|隔开 (string query )
     */
    post: (p, c) =>
      $.post("/api/sms/study/studentQuestion/saveForClient", p, c),
  },

  /**
   * 学生答题记录
   */
  studentSubject_handSubject: {
    /*
     * 交卷(返回练习id)
     * answers 答案 (array query required)
     * belongId 试卷或知识点id或直播课章节id (integer query required)
     * exerciseTime 练习时间（秒） (integer query required)
     * latestExerciseId 只有当继续练习的时候，把这个传给我 (integer query )
     * subjectIds 题目id (array query required)
     * type 类型：历年真题，模拟测试，摸底考试，章节练习，顺序练习 (string query required)
     */
    post: (p, c) => $.post("/api/sms/study/studentSubject/handSubject", p, c),
  },
  studentSubject_studentScore: {
    /*
     * 个人分数
     * courseId 课程id (integer query required)
     */
    get: (p, c) => $.get("/api/sms/study/studentSubject/studentScore", p, c),
  },
  studentSubject_studentStudyReport: {
    /*
     * 学习报告
     */
    get: (p, c) =>
      $.get("/api/sms/study/studentSubject/studentStudyReport", p, c),
  },
  studentSubject_studentSubjectCount: {
    /*
     * 个人刷题数量
     * courseId 课程id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/sms/study/studentSubject/studentSubjectCount", p, c),
  },

  /**
   * 错题集
   */
  studentWrongSubject: {
    /*
     * 移除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/sms/study/studentWrongSubject", p, c),
  },
  studentWrongSubject_addForSelf: {
    /*
     * 增加自考错题（每日一练）
     * answers 答案 (array query required)
     * subjectIds 习题id (array query required)
     */
    post: (p, c) =>
      $.post("/api/sms/study/studentWrongSubject/addForSelf", p, c),
  },
  studentWrongSubject_listCollectPaper: {
    /*
     * 错题集试卷列表
     * courseId 课程id (integer query required)
     * type 类型:历年真题,模拟测试,顺序练习，顺序练习-组卷 (string query required)
     */
    get: (p, c) =>
      $.get("/api/sms/study/studentWrongSubject/listCollectPaper", p, c),
  },
  studentWrongSubject_listCollectSubject: {
    /*
     * 错题集习题列表
     * belongId 归属id (integer query required)
     * type 类型:历年真题,模拟测试,顺序练习 (string query required)
     */
    get: (p, c) =>
      $.get("/api/sms/study/studentWrongSubject/listCollectSubject", p, c),
  },
  studentWrongSubject_listKnowledgeForSelf: {
    /*
     * 自考错题集列表（知识点）
     * courseId 课程id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/sms/study/studentWrongSubject/listKnowledgeForSelf", p, c),
  },
  studentWrongSubject_listSubjectForSelf: {
    /*
     * 自考错题集列表（习题）
     * knowledgeId 知识点id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/sms/study/studentWrongSubject/listSubjectForSelf", p, c),
  },
  studentWrongSubject_removeByBelongId: {
    /*
     * 移除
     * belongId 归属id (integer query required)
     * type 类型:章节练习,历年真题,模拟测试,直播课课后练习 (string query required)
     */
    delete: (p, c) =>
      $.delete("/api/sms/study/studentWrongSubject/removeByBelongId", p, c),
  },
};
